import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input, Button, Table } from "antd";

import { req_multiple_employee, req_edit_tqa_worker } from "../../api";
import storageUtils from "../../utils/storageUtils";
const { Search } = Input;

class DepartmentJudgeAModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    worker: {},
    staff: [],
  };

  static propTypes = {
    worker: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_search_item = async (key) => {
    // console.log(key);
    const result = await req_multiple_employee(
      key,
      storageUtils.getUser().token
    );
    //console.log(result);
    if (result.data === null) {
      message.success("查無此人");
    } else {
      this.setState({ staff: result.data });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_edit_tqa_worker(item, token);
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  onSearch = (value) => {
    //console.log(value);
    if (value.length >= 1) {
      this.api_search_item(value);
    } else {
    }
  };

  onChange = (staff) => {
    const { EmployeeId, TwName } = staff;
    this.props.worker.DepartmentJudgeCodeA = EmployeeId;
    this.props.worker.DepartmentJudgeNameA = TwName;
    // console.log(staff);
    const { WorkGuid, DepartmentJudgeCodeA, DepartmentJudgeNameA } =
      this.props.worker;
    const item = {
      condition: "DEPART_JUDGE_A",
      DepartmentJudgeNameA: DepartmentJudgeNameA,
      DepartmentJudgeCodeA: DepartmentJudgeCodeA,
      WorkGuid: WorkGuid,
    };
    //console.log(item);
    this.api_modify_item(item);
    this.setState({ worker: this.props.worker });
  };

  init_columns = () => {
    this.columns = [
      {
        title: "",
        dataIndex: "",
        render: (item) => {
          const { EmployeeId, TwName } = item;
          return (
            <>
              <>
                {EmployeeId}/{TwName}
              </>
              <Button
                type="primary"
                size="small"
                onClick={() => this.onChange(item)}
              >
                <i className="fas fa-user-cog"></i>
                <span style={{ marginLeft: "4px" }}> 接任</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { DepartmentJudgeCodeA, DepartmentJudgeNameA } = this.props.worker;
    //console.log(this.props.department);
    const { staff } = this.state;
    return (
      <Card>
        <div className="row">
          <div style={{ fontSize: "1.3em" }}>
            當前評核老師：
            {DepartmentJudgeCodeA !== ""
              ? DepartmentJudgeCodeA + "-" + DepartmentJudgeNameA
              : "尚未指定"}
          </div>{" "}
          <Search
            placeholder="接任老師姓名"
            allowClear
            enterButton={
              <>
                <i className="fas fa-search"></i> 查詢
              </>
            }
            size="large"
            onSearch={this.onSearch}
          />
          <Table
            bordered
            scroll={{ y: 380 }}
            dataSource={staff}
            columns={this.columns}
          />
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DepartmentJudgeAModal);
